import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import { useMemo } from "react";
import {
  RequirementTableCallback,
  RequirementTableItemData,
  RequirementTableRowConfig
} from "../../types";
import { buildConfigFields } from "../../utils";
import { usePayeePayoutMethodConfig } from "./configs/payee/usePayeePayoutMethodConfig";
import { usePayerPayoutMethodConfig } from "./configs/payer/usePayerPayoutMethodConfig";

export const usePayoutMethodRequirementTableConfig = (
  callback: RequirementTableCallback,
  requirements: RequirementTableItemData[]
): RequirementTableRowConfig[RequirementType.PayoutMethod] => {
  const payerPayoutMethodConfig = usePayerPayoutMethodConfig(callback);
  const payeePayoutMethodConfig = usePayeePayoutMethodConfig(callback);

  const fields = useMemo(
    () =>
      buildConfigFields<any, RequirementType.PayoutMethod>({
        payerConfig: payerPayoutMethodConfig,
        payeeConfig: payeePayoutMethodConfig,
        getAdditionalData: (requirement: IRequirementResponse) => {
          return requirement.dataSourceMetadata;
        }
      })(),

    [payerPayoutMethodConfig, payeePayoutMethodConfig]
  );

  return {
    ...fields,
    getAdditionalData: () => undefined,
    isLoading: false,
    dataUpdatedAt: ""
  };
};
